module.exports = __webpack_public_path__ + "fonts/iconfont.e278e346.ttf";